"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let PaymentOperatingOsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.windows = new Array();
    this.mac = new Array();
    this.android = new Array();
    this.linux = new Array();
  }
};
PaymentOperatingOsModel.model = "payment.virtualdesktop.options.create.os";
PaymentOperatingOsModel = __decorateClass([
  Annotation.ModelMeta
], PaymentOperatingOsModel);
export let PaymentOperatingUaModel = class extends CoreModel {
};
PaymentOperatingUaModel.model = "payment.virtualdesktop.options.create.useragent";
PaymentOperatingUaModel = __decorateClass([
  Annotation.ModelMeta
], PaymentOperatingUaModel);
export let PaymentResolutionModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
  }
};
PaymentResolutionModel.model = "payment.virtualdesktop.options.create.resolution";
PaymentResolutionModel = __decorateClass([
  Annotation.ModelMeta
], PaymentResolutionModel);
export let PaymentLanguagesModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
  }
};
PaymentLanguagesModel.model = "payment.virtualdesktop.options.create.language";
PaymentLanguagesModel = __decorateClass([
  Annotation.ModelMeta
], PaymentLanguagesModel);
export let PaymentTimezonesModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
  }
};
PaymentTimezonesModel.model = "payment.virtualdesktop.options.create.timezone";
PaymentTimezonesModel = __decorateClass([
  Annotation.ModelMeta
], PaymentTimezonesModel);
export let PaymentDefaultSelectionModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.language_id = "";
    this.timezone_id = "";
  }
};
PaymentDefaultSelectionModel.model = "payment.virtualdesktop.options.create.country_default_selection";
PaymentDefaultSelectionModel = __decorateClass([
  Annotation.ModelMeta
], PaymentDefaultSelectionModel);
export let PaymentOperatingSystemsModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
    this.sort = 0;
  }
};
PaymentOperatingSystemsModel.model = "payment.virtualdesktop.options.create.country_support_os";
PaymentOperatingSystemsModel = __decorateClass([
  Annotation.ModelMeta
], PaymentOperatingSystemsModel);
export let PaymentBrowsersModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
    this.sort = 0;
  }
};
PaymentBrowsersModel.model = "payment.virtualdesktop.options.create.country_support_browser";
PaymentBrowsersModel = __decorateClass([
  Annotation.ModelMeta
], PaymentBrowsersModel);
export let PaymentRegionDefaultSelectionModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.region_id = "";
    this.timezone_id = "";
    this.language_id = "";
    this.region_guid = "";
  }
};
PaymentRegionDefaultSelectionModel.model = "payment.virtualdesktop.options.create.country_region_default_selection";
PaymentRegionDefaultSelectionModel = __decorateClass([
  Annotation.ModelMeta
], PaymentRegionDefaultSelectionModel);
export let PaymentCountriesModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
    this.browsers = new Array();
    this.default_selection = new PaymentDefaultSelectionModel();
    this.operating_systems = new Array();
    this.region_default_selection = new Array();
  }
};
PaymentCountriesModel.model = "payment.virtualdesktop.options.create.country";
PaymentCountriesModel = __decorateClass([
  Annotation.ModelMeta
], PaymentCountriesModel);
export let PaymentComputerConfigModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.countries = new Array();
    this.os = new PaymentOperatingOsModel();
    this.useragent = new PaymentOperatingUaModel();
    this.resolution = new Array();
    this.languages = new Array();
    this.timezones = new Array();
  }
};
PaymentComputerConfigModel.model = "payment.computer_config";
PaymentComputerConfigModel = __decorateClass([
  Annotation.ModelMeta
], PaymentComputerConfigModel);
